import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { deleteExercise, fetchExercises } from '../../../redux/slices/admin/exerciseSlice'; 
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const ExercisesTable = ({ onEdit, handlePageChange }) => {
  const dispatch = useDispatch();
  const { exercises, currentExercisePage, totalExercisePages } = useSelector((state) => state.exercises);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) { 
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  useEffect(() => {
    dispatch(fetchExercises());
  }, [dispatch]);

  const handleDelete = (id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this exercise?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteExercise(id))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-users table-alex printarea">
          <thead>
            <tr>
              <th>Exercise Name</th>
              <th>Category</th>
              <th>Type</th>
            {/* <th>Sets</th>
<th>Reps</th> */}
              <th>Video Url</th>
              <th className="noprint">Action</th>
            </tr>
          </thead>
          <tbody>
            {exercises && exercises.length > 0 ? (
              exercises.map((exercise) => (
                <tr key={exercise.id}>
                  <td>
                    <div className="text-start">{exercise.training_name}</div>
                  </td>
                  <td>
                    <div>{exercise.category_name_display}</div>
                  </td>
                  <td>
                   <div>{exercise.setsweight_or_timedistance == 'WEIGHT-SETS'? 'Sets & Reps' : 'Time & Distance'}</div>
                  </td>

                 
                   <td>
                    <div>{exercise.video_url}</div>
                  </td>
                  <td className="noprint">
                    <div className="text-center position-relative" ref={dropdownRef}>
                      <button 
                        type="button" 
                        className="bg-transparent border-0 p-0 btn-vert-dots" 
                        onClick={(e) => toggleDropdown(exercise.id, e)}
                      >
                        <img src={optionsIcon} alt="Options" />
                      </button>
                      {activeDropdown === exercise.id && (
                        <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                          <li>
                            <a className="dropdown-item" onClick={() => onEdit(exercise)}>
                              <img src={editIcon} alt="Edit" /> Edit
                            </a>
                          </li>

                          {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                          <li>
                            <a className="dropdown-item" onClick={() => handleDelete(exercise.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                          )}

                        </ul>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">No exercises found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
 
      <Pagination 
        currentPage={currentExercisePage} 
        totalPages={totalExercisePages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default ExercisesTable;